import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import UpscaleUploadView from "./UpscaleUploadView";

function UpscaleImageMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "AI Upscale Image For Free Online",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/upscale_image", title: "Image Unscaler Tool" },
    data2: { link: "/upscale_image", title: "AI Image Upscaler Online" },
    data3: {
      link: "/upscale_image",
      title: "AI Image Upscaler 4K",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Upscale images online instantly. Increase image resolution, enhance photo quality and enlarge images without losing clarity using our AI image upscaler."
      ></meta>
      <meta
        name="keywords"
        content="upscale image, image upscaler, ai image upscaler, increase image resolution, enhance image quality, enlarge image online, upscale images online, photo upscaler, image resolution enhancer, image enlarger, ai photo upscaler, upscale image free, image enhancement tool, image quality improver, super resolution image, image upscaler free, upscale image ai, image upscaler 4k, image upscaler 2k, image upscaler HD, image upscaler UHD,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PDF View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = 9.9mb */}
        {showEditFileScreen ? (
          <UpscaleUploadView
            maxFileSize={2 * 1024 * 1024}
            allowedFileExtensions={["jpeg", "jpg", "png"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
            }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our upscale image website helps users enhance image resolution and quality effortlessly using advanced image processing technology. With a powerful image upscaler, you can increase the size of low resolution photos while maintaining sharpness, details, and natural colors. This online image upscaling tool is perfect for photographers, designers, e-commerce sellers, marketers, and everyday users who want to improve photo quality without complex editing software. Using an upscale image online solution allows you to enlarge images for websites, social media, presentations, and print materials with professional results. Modern image upscaler tools support popular formats such as JPG, PNG, and WebP and use smart algorithms to reduce blur and pixelation. Whether you want to enhance old photos, prepare high resolution visuals, or optimize images for digital platforms, an upscale image website offers a fast, easy, and reliable way to improve image quality. From creative projects to business use, image upscaling is an essential tool for producing clear, high quality images that look great on any screen." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Offline",
            step3: "Upscale",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="Upscale Image Tool"
          why_use={[
            {
              title: "Improve Image Resolution and Quality",
              description:
                "This upscale image website helps increase image resolution while preserving details and sharpness. Using an image upscaler improves photo quality without blurring or pixelation.",
            },
            {
              title: "Enhance Low Resolution Photos",
              description:
                "Image upscaling tools are ideal for improving small or low quality images, making them suitable for modern displays and professional use.",
            },
            {
              title: "Perfect for Print and High Resolution Displays",
              description:
                "Our upscale image online tool prepares images for printing, large screens, and presentations by enlarging images with high clarity.",
            },
            {
              title: "Save Time Compared to Manual Editing",
              description:
                "Using an image upscaler online eliminates the need for complex photo editing software, allowing quick and efficient image enhancement.",
            },
            {
              title: "Useful for Designers and Content Creators",
              description:
                "Designers, photographers, and marketers rely on upscale image websites to enhance visuals for websites, ads, and social media.",
            },
            {
              title: "Maintain Natural Colors and Details",
              description:
                "Modern image upscaler tools use smart algorithms to preserve textures, colors, and edges while upscaling images.",
            },
            {
              title: "Supports Multiple Image Formats",
              description:
                "Our upscale image website supports JPG, PNG, WebP, and other formats, making it easy to upscale images of any type.",
            },
            {
              title: "Works Across Devices and Platforms",
              description:
                "Upscale image online tools work seamlessly on desktop and mobile browsers without requiring installation.",
            },
            {
              title: "Enhance Old or Compressed Images",
              description:
                "Image upscaling helps restore clarity in old, scanned, or heavily compressed photos.",
            },
          ]}
        />
        {/* Download on Appsroe */}
        <MiscDownloadOnAppStore
          id={`https://apps.apple.com/app/id${1598764248}`}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default UpscaleImageMain;
